export const AppConfig = {
  apiBaseUrl: import.meta.env.VITE_ADMIN_API_URL,
  storageName: 'admin_storage',
};
